// @flow
const isLogEnableElement = (element:HTMLElement) : boolean => {
    return element.dataset.logEnable === "true";
}



const submitLogEvent =  (clickEvent:MouseEvent) : void => {
    const currentTarget: HTMLElement = ((clickEvent.currentTarget: any): HTMLElement);
    if (isLogEnableElement(currentTarget)){
        const headers = new Headers({
            "Content-Type": `application/json;charset=UTF-8`,
        });

        const requestBody = {
            token : currentTarget.dataset.logToken
        };

        fetch(`/search/api/log`, {
            method: `POST`,
            headers,
            body: JSON.stringify(requestBody)
        });
    }
};

const registerClickEvent = (productElement:HTMLElement) : void => {
    const logToken:string = productElement.dataset.logToken;
    const loggableElements = [...productElement.querySelectorAll("[data-log-enable='true']")];
    loggableElements.forEach(loggableElement => {
        loggableElement.dataset.logToken = logToken;
        loggableElement.addEventListener('click', submitLogEvent,{capture:true});
    });

};




const  initLearning = (win: WindowProxy) : void => {
    const productElementsToLog =  [...win.document.querySelectorAll('[data-log-token]')];
    productElementsToLog.forEach(element => registerClickEvent(element));
};


export default initLearning;

